import styled from "styled-components";

export const Container = styled.div`
  background: orangered;
  width: ${(props) => (props.widths ? props.widths : "")};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 2em;
  margin: ${(props) => (props.margin ? props.margin : "")};
  .link {
    text-decoration: none;
    padding: 0;
  }
`;

export const Image = styled.div`
  min-height: 200px;
  padding: 1em;

  img {
    display: block;
    margin: auto;
    width: 60%;
    height: 100%;
  }
`;
export const H2 = styled.h2`
  text-align: center;
  font-size: 2em;
  color: #eee;
  /* padding: 1em 0; */
`;
export const P = styled.p`
  text-align: center;
  font-size: 0.95em;
  color: #eee;
`;
export const Button = styled.button`
  display: block;
  background: #eee;
  color: #555;
  padding: 1em 3em;
  outline: none;
  border: 0.5px solid orangered;
  border-radius: 0.25em;
  margin: 1.2em 0;
  cursor: pointer;
`;
